import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { EditReceive_Log, GetReceivePartsByPoID } from "../../api";
import { validateField } from "../../contexts/Utils";
import { Button, Header } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import DoubleField from "../../components/DoubleField";
import TextInputField from "../../components/TextInputField";
import DateInputField from "../../components/DateInputField";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const ReceiveLog = () => {
  const navigate = useNavigate();
  let param = useParams();
  const po_id = param.po_id;
  const gridRef = useRef(null);
  const { currentColor, userID } = useStateContext();
  const [ReceiveParts, setReceiveParts] = useState([]);
  const [ReceiveLog, setReceiveLog] = useState([]);
  const [SnSeries, setSnSeries] = useState([]);
  const [row_id, setrow_id] = useState(-1);
  const [editIndex, setEditIndex] = useState(-1);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);
  const [formData, setFormData] = useState({
    vendor: "",
    vendor_invoice_no: "",
    order_date: "",
    recv_by: "",
    recv_date: null,
    qty_recv: "",
    qty_reject: "",
    date_code: "",
    lot_number: "",
    mfg_date: null,
    serialized: false,
    notes: "",
  });
  const [snFormData, setSnFormData] = useState({
    type: "auto",
    sn: "",
    first_sn: "",
    last_sn: "",
    mfg_sn: "",
    note: "",
    note_all: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const customersGrid = [
    {
      field: "item_no",
      headerText: "#",
      width: "55",
      textAlign: "right",
    },
    {
      field: "part_number",
      headerText: "Part",
      width: "100",
      textAlign: "left",
    },
    {
      field: "part_description",
      headerText: "Description",
      width: "320",
      textAlign: "left",
    },
    {
      field: "mfg_name",
      headerText: "Mfg Name",
      width: "100",
      textAlign: "center",
    },
    {
      field: "mfg_pn",
      headerText: "Mfg PN",
      width: "100",
      textAlign: "center",
    },
    {
      field: "quantity",
      headerText: "Qty",
      width: "80",
      textAlign: "Right",
    },
    {
      field: "quantity_recv",
      headerText: "Qty Rcv to Date",
      width: "150",
      textAlign: "right",
    },
    {
      field: "quantity_reject",
      headerText: "Qty Rej to Date",
      width: "145",
      textAlign: "Right",
    },
    {
      field: "last_quantity_recv",
      headerText: "Last Qty Rcv",
      width: "130",
      textAlign: "right",
    },
    {
      field: "last_quantity_reject",
      headerText: "Last Qty Rej",
      width: "130",
      textAlign: "right",
    },
  ];

  function ResetSNFormData() {
    setSnFormData({
      type: "auto",
      sn: "",
      first_sn: "",
      last_sn: "",
      mfg_sn: "",
      note: "",
      note_all: "",
    });
    setSnSeries([]);
  }

  function ResetFormData() {
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const part = ReceiveParts.find((item) => item.item_no === row_id);
    setFormData((prev) => ({
      ...prev,
      recv_by: "",
      recv_date: now.toISOString().slice(0, 19).split("T")[0],
      qty_recv: "0",
      qty_reject: "0",
      date_code: "",
      lot_number: "",
      mfg_date: null,
      serialized: part.serialized || null,
      notes: "",
    }));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      ["sn", "first_sn", "last_sn", "mfg_sn", "note", "note_all"].includes(name)
    )
      setSnFormData((prev) => ({ ...prev, [name]: value }));
    else if (name === "type")
      setSnFormData({
        type: value,
        sn: "",
        first_sn: "",
        last_sn: "",
        mfg_sn: "",
        note: "",
        note_all: "",
      });
    else if (name === "qty_recv" || name === "qty_reject") {
      ResetSNFormData();
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleRadioChange = (e) => {
    const name = e.target.value;
    setSnFormData((prev) => ({
      ...prev,
      type: name,
      sn: "",
      first_sn: "",
      last_sn: "",
      mfg_sn: "",
      note: "",
      note_all: "",
    }));
    setSnSeries([]);
  };

  const handleRecvEditClick = (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    setEditIndex(row_id);
    ResetFormData();
    ResetSNFormData();
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Purchase");
  };

  const handleCancelClick = (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();

    setrow_id(-1);
    setEditIndex(-1);
    ResetFormData();
    ResetSNFormData();
    gridRef.current.clearSelection();
  };

  const handleUpdateItemClick = (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    const tQty =
      parseInt(formData.qty_recv) + parseInt(formData.qty_reject) || 0;
    if (!newErrors["qty_recv"] && !newErrors["qty_reject"] && tQty <= 0)
      newErrors["qty_recv"] = "New Qty Received must be greater than ZERO!";
    const part = ReceiveParts.find((item) => item.item_no === editIndex);
    if (
      !newErrors["qty_recv"] &&
      parseFloat(formData.qty_recv) + part.quantity_recv > part.quantity
    )
      newErrors["qty_recv"] =
        "Qty Received cannot be greater than Ordered Qty!";
    setErrors(newErrors);
    if (
      part.serialized &&
      snFormData.type === "manual" &&
      !newErrors["qty_recv"] &&
      !newErrors["qty_reject"] &&
      tQty !== SnSeries.length
    ) {
      showErrorToast("Error!", "Enter all SNs before updating Receive Log!");
      setLoadBtn(false);
      return;
    }
    let snSer = [];
    if (
      part.serialized &&
      snFormData.type === "auto" &&
      !newErrors["qty_recv"] &&
      !newErrors["qty_reject"]
    ) {
      if (!snFormData.first_sn || snFormData.first_sn === "")
        newErrors["first_sn"] = "Invalid field!";
      else if (!snFormData.last_sn || snFormData.last_sn === "")
        newErrors["last_sn"] = "Invalid field!";
      else {
        const matchF = snFormData.first_sn.match(/^(.*?)(\d+)$/);
        const matchL = snFormData.last_sn.match(/^(.*?)(\d+)$/);
        const letterF = matchF ? matchF[1] : snFormData.first_sn;
        const numberF = matchF && parseInt(matchF[2]) ? matchF[2] : null;
        const letterL = matchL ? matchL[1] : snFormData.last_sn;
        const numberL = matchL && parseInt(matchL[2]) ? matchL[2] : null;

        if (letterF !== letterL)
          newErrors["last_sn"] = "Last SN should follow same pattern!";
        else if (!numberF) newErrors["first_sn"] = "Invalid field!";
        else if (!numberL) newErrors["last_sn"] = "Invalid field!";
        else if (numberL - numberF + 1 !== tQty)
          newErrors["last_sn"] =
            "The difference between First and Last SN is not equal to Total Qty!";
        else {
          for (let i = numberF; i < parseInt(tQty) + parseInt(numberF); i++) {
            snSer.push({
              item_no: part.item_no,
              part_id: part.part_id,
              sn: letterF + i,
              mfg_sn: "",
              note: snFormData.note_all,
            });
          }
        }
      }
    }
    //OTHER VALIDATION: CHECK IF SN EXIST IN DB
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    setReceiveLog((prev) => [
      ...prev,
      {
        item_no: part.item_no,
        quantity: part.quantity,
        part_id: part.part_id,
        recv_by: formData.recv_by || "",
        recv_date: formData.recv_date || null,
        quantity_recv: parseFloat(formData.qty_recv),
        quantity_reject: parseFloat(formData.qty_reject),
        date_code: formData.date_code,
        lot_code: formData.lot_number,
        mfg_date: formData.mfg_date || null,
        note: formData.notes,
        sns:
          part.serialized && snFormData.type === "manual"
            ? SnSeries
            : part.serialized && snFormData.type === "auto"
              ? snSer
              : [],
      },
    ]);
    setReceiveParts((items) => {
      return items.map((item) => {
        if (item.item_no === editIndex)
          return {
            ...item,
            quantity_recv: item.quantity_recv + parseFloat(formData.qty_recv),
            quantity_reject:
              item.quantity_reject + parseFloat(formData.qty_reject),
            last_quantity_recv: parseFloat(formData.qty_recv),
            last_quantity_reject: parseFloat(formData.qty_reject),
          };
        return item;
      });
    });
    setrow_id(-1);
    setEditIndex(-1);
    ResetFormData();
    ResetSNFormData();
  };

  const handleSNNextClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(snFormData).forEach((key) => {
      const error = validateField(key, snFormData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const part = ReceiveParts.find((item) => item.item_no === editIndex);
    setSnSeries((prev) => [
      ...prev,
      {
        item_no: part.item_no,
        part_id: part.part_id,
        sn: snFormData.sn,
        mfg_sn: snFormData.mfg_sn,
        note: snFormData.note,
      },
    ]);
    setSnFormData((prev) => ({
      ...prev,
      sn: "",
      first_sn: "",
      last_sn: "",
      mfg_sn: "",
      note: "",
      note_all: "",
    }));
  };

  const handleSubmit = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    setLoadBtn(true);

    if (ReceiveLog?.length <= 0) {
      showErrorToast("Error!", "No Items received!");
      setLoadBtn(false);
      return;
    }
    if (!window.confirm(`Confirm save of all received logs?`)) {
      setLoadBtn(false);
      return;
    }
    try {
      const response = await EditReceive_Log(po_id, userID, ReceiveLog);
      if (response.success) {
        showSuccessToast("Success!", "Receive Log Updated Successfully");
        navigate("/Purchase");
      } else
        showErrorToast(
          "Error!",
          "Receive Log Failed to Update\n\n" + response.message,
        );
    } catch (error) {
      showErrorToast("Error!", "Receive Log Failed to Update");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleRowSelected = (args) => setrow_id(args.data.item_no);

  const handleRowDeSelected = () => setrow_id(-1);

  useEffect(() => {
    if (po_id) {
      TimeoutUtility.resetTimeout();
      setloading(true);
      trackPromise(
        GetReceivePartsByPoID(po_id)
          .then((resp) => {
            setFormData((prev) => ({
              ...prev,
              vendor: resp.data[0].vendor,
              vendor_invoice_no: resp.data[0].vendor_invoice_no,
              order_date: resp.data[0].order_date
                ? resp.data[0].order_date.split("T")[0]
                : "",
            }));
            const partList = resp.data.map((item) => {
              return {
                item_no: item.item_no || "0",
                part_id: item.part_id,
                part_number: item.part_number || "-",
                part_description: item.part_description || "-",
                stockroom_location: item.stockroom_location || "-",
                mfg_name: item.mfg_name || "-",
                mfg_pn: item.mfg_pn || "-",
                serialized: item.serialized || false,
                quantity: item.quantity || 0,
                quantity_recv: item.quantity_recv || 0,
                quantity_reject: item.quantity_reject || 0,
                last_quantity_recv: item.last_quantity_recv || 0,
                last_quantity_reject: item.last_quantity_reject || 0,
              };
            });
            setReceiveParts(partList);
          })
          .catch((err) => console.log(err.message))
          .finally(() => setloading(false)),
      );
    }
  }, [po_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="RECEIVE LOG" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} className="container-col">
              <TextInputField
                label="PO #:"
                name="po_id"
                value={po_id}
                placeholder="PO #"
                readOnly
                style={{ border: "0", cursor: "default" }}
              />
            </Col>
            <Col md={3} className="container-col">
              <DateInputField
                label="Order Date:"
                name="order_date"
                value={formData.order_date}
                placeholder="Order Date"
                readOnly
                style={{ border: "0", cursor: "default" }}
              />
            </Col>
            <Col md={3} className="container-col">
              <TextInputField
                label="Vendor:"
                name="vendor"
                value={formData.vendor}
                placeholder="Vendor"
                readOnly
                style={{ border: "0", cursor: "default" }}
              />
            </Col>
            <Col md={3} className="container-col">
              <TextInputField
                label="Vendor Invoice #:"
                name="vendor_invoice_no"
                value={formData.vendor_invoice_no}
                placeholder="Vendor Invoice #"
                readOnly
                style={{ border: "0", cursor: "default" }}
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={12} className="container-col">
              <div className="flex justify-end">
                <button
                  style={{
                    padding: "8px",
                    backgroundColor:
                      row_id < 0 || editIndex >= 0 ? "grey" : currentColor,
                    color: "#fff",
                    borderRadius: "10px",
                    margin: "2px",
                    fontSize: "14px",
                  }}
                  onClick={handleRecvEditClick}
                  disabled={row_id < 0 || editIndex >= 0}
                >
                  Edit / Rcv
                </button>
              </div>
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={12} className="container-col">
              {loading || promiseInProgress ? (
                <LoadingIndicator />
              ) : (
                <GridComponent
                  ref={gridRef}
                  dataSource={ReceiveParts}
                  height="calc(24vh - 60px)"
                  allowResizing
                  rowSelected={handleRowSelected}
                  rowDeselected={handleRowDeSelected}
                  rowHeight={30}
                  className="custom-grid1"
                  disabled={editIndex >= 0}
                >
                  <ColumnsDirective>
                    {customersGrid.map((item, index) => (
                      <ColumnDirective key={index} {...item} />
                    ))}
                  </ColumnsDirective>
                  <Inject services={[Resize]} />
                </GridComponent>
              )}
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={12} className="container-col">
              <div className="flex justify-end">
                <button
                  style={{
                    padding: "8px",
                    backgroundColor: editIndex < 0 ? "grey" : currentColor,
                    color: "#fff",
                    borderRadius: "10px",
                    margin: "2px",
                    fontSize: "14px",
                  }}
                  disabled={editIndex < 0}
                  onClick={handleUpdateItemClick}
                >
                  Update Item
                </button>
                <button
                  style={{
                    padding: "8px",
                    backgroundColor: editIndex < 0 ? "grey" : currentColor,
                    color: "#fff",
                    borderRadius: "10px",
                    margin: "2px",
                    fontSize: "14px",
                  }}
                  disabled={editIndex < 0}
                  onClick={handleCancelClick}
                >
                  Cancel
                </button>
              </div>
            </Col>
          </Row>
          <Row xs={1} sm={1}>
            <Col md={6} xl={4} className="container-col">
              <TextInputField
                label="Recv By:"
                name="recv_by"
                value={formData.recv_by}
                onChange={handleChange}
                placeholder="Recv By"
                error={errors.recv_by}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={3} xl={2} className="container-col">
              <DateInputField
                label="Receive Date:"
                name="recv_date"
                value={formData.recv_date}
                onChange={handleChange}
                placeholder="Receive Date"
                compulsory={true}
                error={errors.recv_date}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={3} xl={2} className="container-col">
              <DateInputField
                label="Mfg Date:"
                name="mfg_date"
                value={formData.mfg_date}
                onChange={handleChange}
                placeholder="Mfg Date"
                compulsory={true}
                error={errors.mfg_date}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={3} xl={2} className="container-col">
              <DoubleField
                label="New Qty Recv:"
                name="qty_recv"
                value={formData.qty_recv}
                onChange={handleChange}
                placeholder="New Qty Recv"
                min="0"
                step="1.00"
                compulsory={true}
                error={errors.qty_recv}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={3} xl={2} className="container-col">
              <DoubleField
                label="New Qty Reject:"
                name="qty_reject"
                value={formData.qty_reject}
                onChange={handleChange}
                placeholder="New Qty Reject"
                min="0"
                step="1.00"
                compulsory={true}
                error={errors.qty_reject}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={3} xl={2} className="container-col">
              <TextInputField
                label="Date Code:"
                name="date_code"
                value={formData.date_code}
                onChange={handleChange}
                placeholder="Date Code"
                error={errors.date_code}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={3} xl={2} className="container-col">
              <TextInputField
                label="Lot Number:"
                name="lot_number"
                value={formData.lot_number}
                onChange={handleChange}
                placeholder="Lot Number"
                error={errors.lot_number}
                disabled={editIndex < 0}
              />
            </Col>
            <Col md={12} xl={8} className="container-col">
              <TextInputField
                label="Notes:"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                placeholder="Notes"
                error={errors.notes}
                style={{ width: "95.5%" }}
                disabled={editIndex < 0}
              />
            </Col>
          </Row>
          {formData.serialized && (
            <Row xs={1} sm={1} className="pt-8">
              <label className="text-xl">Serialized Parts Info:</label>
              <Row xs={1} sm={1} style={{ marginTop: "-8px" }}>
                <Col md={3} xl={2}>
                  <label className="text-lg w-100 text-center mt-8">
                    <input
                      type="radio"
                      value="manual"
                      id="manual"
                      name="type"
                      onChange={handleRadioChange}
                      style={{ marginRight: "4px" }}
                      checked={snFormData.type === "manual"}
                      disabled={editIndex < 0}
                    />
                    Manual
                  </label>
                </Col>
                <Col md={4} xl={2}>
                  <TextInputField
                    label={`SN # ${SnSeries.length + 1}:`}
                    name="sn"
                    value={snFormData.sn}
                    onChange={handleChange}
                    placeholder="SN"
                    error={errors.sn}
                    disabled={editIndex < 0 || snFormData.type !== "manual"}
                  />
                </Col>
                <Col md={5} xl={2}>
                  <TextInputField
                    label="Mfg SN:"
                    name="mfg_sn"
                    value={snFormData.mfg_sn}
                    onChange={handleChange}
                    placeholder="Mfg SN"
                    error={errors.mfg_sn}
                    disabled={editIndex < 0 || snFormData.type !== "manual"}
                  />
                </Col>
                <Col md={3} className="d-xl-none"></Col>
                <Col md={7} xl={5} className="container-col">
                  <TextInputField
                    label="Note:"
                    name="note"
                    value={snFormData.note}
                    onChange={handleChange}
                    placeholder="Note"
                    error={errors.note}
                    style={{ width: "100%" }}
                    disabled={editIndex < 0 || snFormData.type !== "manual"}
                  />
                </Col>
                <Col md={2} xl={1}>
                  <button
                    style={{
                      padding: "8px",
                      backgroundColor:
                        editIndex < 0 ||
                        snFormData.type !== "manual" ||
                        parseInt(formData.qty_recv) +
                          parseInt(formData.qty_reject) <=
                          SnSeries?.length
                          ? "grey"
                          : currentColor,
                      color: "#fff",
                      borderRadius: "10px",
                      marginTop: "36px",
                      fontSize: "14px",
                    }}
                    disabled={
                      editIndex < 0 ||
                      snFormData.type !== "manual" ||
                      parseInt(formData.qty_recv) +
                        parseInt(formData.qty_reject) <=
                        SnSeries?.length
                    }
                    onClick={handleSNNextClick}
                  >
                    {parseInt(formData.qty_recv) +
                      parseInt(formData.qty_reject) ===
                    SnSeries?.length + 1
                      ? `Finish`
                      : `Next`}
                  </button>
                </Col>
              </Row>
              <Row xs={1} sm={1}>
                <Col md={3} xl={2}>
                  <label className="text-lg w-100 text-center mt-4">
                    <input
                      type="radio"
                      value="auto"
                      id="auto"
                      name="type"
                      onChange={handleRadioChange}
                      style={{ marginRight: "4px" }}
                      checked={snFormData.type === "auto"}
                      disabled={editIndex < 0}
                    />
                    Automatic
                  </label>
                </Col>
                <Col md={4} xl={2}>
                  <TextInputField
                    label="First SN:"
                    name="first_sn"
                    value={snFormData.first_sn}
                    onChange={handleChange}
                    placeholder="First SN"
                    error={errors.first_sn}
                    disabled={editIndex < 0 || snFormData.type !== "auto"}
                  />
                </Col>
                <Col md={5} xl={2}>
                  <TextInputField
                    label="Last SN:"
                    name="last_sn"
                    value={snFormData.last_sn}
                    onChange={handleChange}
                    placeholder="Last SN"
                    error={errors.last_sn}
                    disabled={editIndex < 0 || snFormData.type !== "auto"}
                  />
                </Col>
                <Col md={3} className="d-xl-none"></Col>
                <Col md={9} xl={6} className="container-col">
                  <TextInputField
                    label="Note For All:"
                    name="note_all"
                    value={snFormData.note_all}
                    onChange={handleChange}
                    placeholder="Note"
                    error={errors.note_all}
                    style={{ width: "90%" }}
                    disabled={editIndex < 0 || snFormData.type !== "auto"}
                  />
                </Col>
              </Row>
            </Row>
          )}
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="40px"
          text="SAVE ALL"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="40px"
          text="BACK"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ReceiveLog;
